import { createRootRoute, Navigate, Outlet } from '@tanstack/react-router';

import Administrator from '@/_containers/administrator';
import { PageHeaderProvider } from '@/_shared/page-header-context/page-header-context-provider';

export const Route = createRootRoute({
  component: () => (
    <PageHeaderProvider>
      <Administrator />
      <Outlet />
    </PageHeaderProvider>
  ),
  notFoundComponent: () => <Navigate to="/" replace />,
});
